export default "__VITE_PUBLIC_ASSET__e2648d41__"